import React from 'react'

import { Navigate, Route, Routes } from 'react-router-dom'

import { Paths } from 'common/routes'
import { Dashboard } from 'features/dashboard'
import { Statistics } from 'features/dashboard/Statistics/Statistics'
import { Simulator } from 'features/simulator'
import { Page404 } from 'layout'

export const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Dashboard />}>
        <Route path="/" element={<Navigate to={Paths.Info} />} />
        <Route path={Paths.Info} element={<Statistics />} />
        <Route path={`${Paths.Simulator}:id`} element={<Simulator />} />
        <Route path="404" element={<Page404 />} />
        <Route path="*" element={<Navigate to="404" />} />
      </Route>
    </Routes>
  )
}
